import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Cookies from "js-cookie";
import './Qna.css';
import * as actions from './Actions';
import { fetchInitialData2 } from "../fetchData";
// import Right from '../right/Right';
import Service from '../service/Service';
import Question from './common/Question';
import UserListOverlay from './common/UserListOverlay';

const service = new Service();

class IntentMapping extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let articleData = [];
        let similarQueData = [];
        this.totalCount = 0;
        this.similarQueCount = 0;
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['result'] && serverSideData['data1']['msg'] == "1") {
                articleData = serverSideData['data1']['result'];
            }
            if (serverSideData['data2'] && serverSideData['data2']['QuestionData'] && serverSideData['data2']['msg'] == "1") {
                similarQueData = serverSideData['data2']['QuestionData'];
                this.similarQueCount = parseInt(serverSideData['data2']['search_cnt']);
            }
        }
        let urlAry = this.props.match.params.title.split('-')
        this.questionId = urlAry.pop();
        this.questionTitle = urlAry.join(" ") + "?";;
        this.state = {
            initialData: initialData,
            articleData: articleData,
            similarQueData: similarQueData,
            metaTitle: "Questions & Answers: Pregnancy, Baby Care, Parenting Tips & Advice",
            metaDescription: [],
            undermoderation : ''
        };
        this.qnaPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.match.params.page);
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 100;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        var qUrl = reqUrl.split('/')[3];
        var id = "";
        var question = "";
        if (qUrl.includes('?')) {
            let mainUrl = qUrl.split('?')[0].split('-');
            id = mainUrl.pop();
            question = mainUrl.join(" ") + "?";
        } else {
            let mainUrl = qUrl.split('-');
            id = mainUrl.pop();
            question = mainUrl.join(" ") + "?";
        }
        let obj1 = {
            url: global.api_url + "blogs/getsimilararticle",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "searchtext": question
            })
        };
        let obj2 = {
            url: global.api_url + "getSearchData",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "searchKey": question,
                "sort_by": 'ansCnt',
                "sort_value": 'desc',
                "isIntent": true,
                "isDesk": true
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {
        // service.disableCutCopyPaste('post_answer_text');
        // service.disableCutCopyPaste('post_question_text');
        document.addEventListener("click", actions.domClick);
        service.loadImages();
        if (navigator.onLine) {
            let size = 100;
            if (this.qnaPageNo > 1) {
                size = 10 * this.qnaPageNo;
            }
            if (!this.state.articleData || (this.state.articleData && this.state.articleData.length < 1)) {
                service.showLoader();
                this.qnaArticleData(1, 10);
            } else {
                localStorage.setItem('qnaArticleDetails_' + this.questionId, JSON.stringify(this.state.articleData));
            }
            if (!this.state.similarQueData || (this.state.similarQueData && this.state.similarQueData.length < 1)) {
                service.showLoader();
                this.qnaSimilarQueData(1, 10);
            } else {
                localStorage.setItem('qnaSimilarQueDetails_' + this.questionId, JSON.stringify(this.state.similarQueData));
                localStorage.setItem('qnaSimilarQueDetailsCnt_' + this.questionId, JSON.stringify(this.similarQueCount));
                actions.loadReadMore();
            }
        } else {
            if (localStorage.getItem('qnaArticleDetails_' + this.questionId)) {
                this.setState({ articleData: JSON.parse(localStorage.getItem('qnaArticleDetails_' + this.questionId)) }, () => { service.loadImages(); });
            }
            if (localStorage.getItem('qnaSimilarQueDetails_' + this.questionId)) {
                this.setState({ similarQueData: JSON.parse(localStorage.getItem('qnaSimilarQueDetails_' + this.questionId)) }, () => { service.loadImages(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('qnaSimilarQueDetailsCnt_' + this.questionId)) {
                this.similarQueCount = localStorage.getItem('qnaSimilarQueDetailsCnt_' + this.questionId);
            }
            service.hideLoader();
        }
        window.scrollTo(0,0);
        this.setState({undermoderation : Cookies.get('undermoderation')});
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    formatArticleDate(date) {
        let monthAry = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        let month = monthAry[new Date(date).getMonth()];
        let day = new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate();
        let year = new Date(date).getFullYear();
        return month + " " + day + ", " + year;
    }

    qnaArticleData(pageno, size) {
        var url = global.api_ci_url + "qna/getsimilararticle";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "searchtext": this.questionTitle
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.articleData && this.state.articleData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ articleData: json['result'] }, () => { service.loadImages(); });
                    } else {
                        let ary = this.state.articleData;
                        this.setState({ articleData: ary.concat(json['result']) }, () => { service.loadImages(); });
                    }
                } else {
                    localStorage.setItem('qnaArticleDetails_' + this.questionId, JSON.stringify(json['result']));
                    this.setState({ articleData: json['result'] }, () => { service.loadImages(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    qnaSimilarQueData(pageno, size) {
        var url = global.api_ci_url + "qna/getSearchData";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "searchKey": this.questionTitle,
            "sort_by": 'ansCnt',
            "sort_value": 'desc',
            "isIntent": true,
            "isDesk": true
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.similarQueData && this.state.similarQueData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ similarQueData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.similarQueData;
                        this.setState({ similarQueData: ary.concat(json['QuestionData']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                } else {
                    localStorage.setItem('qnaSimilarQueDetails_' + this.questionId, JSON.stringify(json['QuestionData']));
                    localStorage.setItem('qnaSimilarQueDetailsCnt_' + this.questionId, JSON.stringify(json['search_cnt']));
                    this.similarQueCount = parseInt(json['search_cnt']);
                    this.setState({ similarQueData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    reloadSimilarQueData(queId, actionType, status) {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            let dataAry = _this.state.similarQueData;
            for (let d = 0; d < dataAry.length; d++) {
                if (dataAry[d]['question_id'] == queId) {
                    if (actionType == "follow") {
                        if (status == 1) {
                            dataAry[d]['que_follow'] = 'true';
                            dataAry[d]['follow_count'] = parseInt(dataAry[d]['follow_count']) + 1;
                        } else {
                            dataAry[d]['que_follow'] = 'false';
                            dataAry[d]['follow_count'] = (parseInt(dataAry[d]['follow_count']) - 1) >= 0 ? parseInt(dataAry[d]['follow_count']) - 1 : 0;
                        }
                    }
                    if (actionType == "abuse") {
                        if (status == 1) {
                            dataAry[d]['que_abuse'] = 'true';
                        } else {
                            dataAry[d]['que_abuse'] = 'false';
                        }
                    }
                }
            }
            _this.setState({ similarQueData: dataAry }, () => { service.loadImages(); actions.loadReadMore(); });
        }, 500)
    }

    render() {
    
        return (
            <main className="qna-main qnadetail-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/qna/questions-answers")} className="R11_9e">Questions & Answers</Link></span>
                    </div>
                    {/* <h1 className="B24_00">Q&A</h1> */}
                </div>
                <div className="sub-container left">
                    <div className="data-container left intent_mapping">
                            {(this.state.undermoderation == "0" || this.state.undermoderation == 0) ? 
                            (
                                <div className="que_posted">
                                    <div className="icon tick-ic" data-icon-font="<"></div>
                                    <span className="M15_42">Your question has been sucessfully posted!</span>
                                    <div className="top-btns">
                                        <Link to={service.getRedirectUrl(`/qna/q/${service.replaceSymbols((this.questionTitle) + '-' + (this.questionId))}`)} className="left">
                                            <span className="M15_pink">VIEW YOUR QUESTION</span>
                                        </Link>
                                        <Link to={service.getRedirectUrl("/qna/questions-answers")} className="right">
                                            <span className="M15_pink">GO TO Q&A</span>
                                        </Link>
                                    </div>
                                </div>
                            ) :
                            (
                                <div className="que_posted">
                                        <div className="icon moderate-ic" data-icon-font="3"></div>
                                        <span className="M15_42">
                                            Your question is under review, click on View your question to check the status
                                        </span>
                                    <div className="top-btns">
                                        <a href="https://parenting.firstcry.ae/my-account/myquestions" className="left">
                                            <span className="M15_pink">VIEW YOUR QUESTION</span>
                                        </a>
                                        <Link to={service.getRedirectUrl("/qna/questions-answers")} className="right">
                                            <span className="M15_pink">GO TO Q&A</span>
                                        </Link>
                                    </div>
                                </div>
                            )}

                        {this.state.articleData && this.state.articleData.length > 0 &&
                            <div className="similar-block">
                                <div className="pink_title_main">
                                    <span className="M14_white">SUGGESTED ARTICLES</span>
                                </div>
                                <div className="pink_line"></div>
                                {this.state.articleData.map((article, index) =>
                                    <div key={index} className="suggested-articles">
                                        <a href={service.getRedirectUrl(article.article_url.replace("http://", "https://"))}>
                                            <span className="article-img left">
                                                {article.imageUrl &&
                                                    <img src={article.imageUrl.replace("http://", "https://")} />
                                                }
                                            </span>
                                            <div className="article-info left">
                                                <span className="article-title M17_42">{article.articleTitle}</span>
                                                <span className="article-date">{this.formatArticleDate(article.date)}</span>
                                            </div>
                                        </a>
                                    </div>
                                )}
                                {/* <div className="view-more">
                                    <span className="view-more-text M14_42">VIEW MORE ARTICLES</span>
                                </div> */}
                            </div>
                        }
                        {this.state.similarQueData && this.state.similarQueData.length > 0 &&
                            <div className="similar-block">
                                <div className="pink_title_main">
                                    <span className="M14_white">SIMILAR QUESTIONS</span>
                                </div>
                                <div className="pink_line"></div>
                                <div className="similar_q">
                                    {this.state.similarQueData &&
                                        <Question questions={this.state.similarQueData} isLanding={false} isShowAbuse={true} checkQId={this.questionId} eleRef={this} isSimilarQue={true} isShowReadMore={true} isAnsCntStrip={false} isAnsCntMoreStrip={false} isShowHeading={false} />
                                    }
                                    {/* <div className="view-more">
                                        <span className="view-more-text M14_42">VIEW MORE QUESTIONS</span>
                                    </div> */}
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <UserListOverlay eleRef={this} />
                {/* <Right url={this.props.match.url} /> */}
            </main>
        )
    }
}

export default IntentMapping;



// WEBPACK FOOTER //
// src/shared/qna/IntentMapping.js